/* splatky-box.js — malý box „Alebo na splátky“ (Tatra banka, Na splátkyTB) na stránke produktu (snippets/cena-na-splatky.liquid).
 *
 * Pokyn Radovana 17. 10. 2026: malý box s tromi prepojenými posuvníkmi (výška úveru, počet splátok, akontácia), každý s poľom na dopísanie čísla;
 * úver + akontácia = cena. Viac informácií = rozbalenie boxu, ešte viac = naša novinka (odkaz). NÁVRH ZNENIA — čaká na schválenie Radovana.
 *
 * Box vykreslí server (Liquid) vo východiskovom stave (najnižšia splátka: najdlhšia doba, nič zaplatené vopred); tento skript len ošetruje zmeny.
 * Udalosti sú delegované na dokument — prežijú výmenu obsahu stránky produktu pri prepnutí výkonu a viac boxov na stránke je nezávislých.
 * Parametre banky (sadzba, doba, úver od–do) nesie box v atribútoch data-* (zdroj: snippets/splatky-parametre.liquid), nič sa tu nezapisuje natvrdo.
 *
 * Blok KS-CORE je ROVNAKÝ ako v sections/kalkulacka-splatok.liquid (test T-spl-12 ich porovnáva znak po znaku) — mení sa na oboch miestach naraz.
 * Zmena zobrazenia (texty, vzhľad) nesmie zmeniť čísla: tie idú len z KS-CORE; test T-spl-4 porovnáva začiatočný stav z Liquidu s KS-CORE na cent.
 */
(function () {
  'use strict';
  if (window.__csSplatkyBox) return;

  /* KS-CORE — čistá logika bez DOM (testuje ju scripts/tema-testy/menu/testy-splatky.mjs) */
  var KS = {};
  /** centy → „9 879,97 €“ (pevné medzery) */
  KS.eur = function (c) {
    var neg = c < 0; c = Math.abs(Math.round(c));
    var e = Math.floor(c / 100), d = c % 100;
    var s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return (neg ? '\u2212' : '') + s + ',' + (d < 10 ? '0' : '') + d + '\u00a0\u20ac';
  };
  /** text zadaný zákazníkom („9 500,5“, „9500.50“) → centy; neplatné → NaN */
  KS.centy = function (t) {
    var s = String(t == null ? '' : t).replace(/[\s\u00a0]/g, '').replace(',', '.');
    if (!/^\d*\.?\d*$/.test(s) || s === '' || s === '.') return NaN;
    return Math.round(Number(s) * 100 + 1e-9);
  };
  /** mesačná sadzba: ročná v % × 365 / 360 / 12 (banka úročí podľa skutočných dní, rok = 360 dní) */
  KS.i = function (sadzba) { return sadzba / 100 * 365 / 360 / 12; };
  /** mesačná splátka v centoch (anuita, zaokrúhlená na cent) */
  KS.splatka = function (uver, n, sadzba) {
    var i = KS.i(sadzba);
    if (i === 0) return Math.round(uver / n);
    var f = Math.pow(1 + i, n);
    return Math.round(uver * i * f / (f - 1));
  };
  /** splátkový kalendár po mesiacoch: úrok sa zaokrúhľuje na cent, posledná splátka dorovná zostatok */
  KS.harmonogram = function (uver, n, sadzba) {
    var i = KS.i(sadzba), s = KS.splatka(uver, n, sadzba), bal = uver, urok = 0;
    for (var k = 1; k < n; k++) { var u = Math.round(bal * i); urok += u; bal = bal + u - s; }
    var u2 = Math.round(bal * i); urok += u2;
    var posl = bal + u2;
    return { splatka: s, posledna: posl, celkom: s * (n - 1) + posl, urok: urok };
  };
  /** RPMN v % na 2 desatinné miesta (poplatok 0 €, rovnaké mesačné intervaly): (1 + i)^12 − 1 */
  KS.rpmn = function (sadzba) { return Math.round((Math.pow(1 + KS.i(sadzba), 12) - 1) * 10000) / 100; };
  /** „6,25“ */
  KS.pct = function (x) { var c = Math.round(x * 100); return Math.floor(c / 100) + ',' + (c % 100 < 10 ? '0' : '') + (c % 100); };
  /** počet mesiacov → „96 mesiacov (8 rokov)“ */
  KS.mesTxt = function (n) {
    var m = n === 1 ? '1 mesiac' : (n >= 2 && n <= 4 ? n + ' mesiace' : n + ' mesiacov');
    if (n % 12 === 0) { var r = n / 12; m += ' (' + (r === 1 ? '1 rok' : (r <= 4 ? r + ' roky' : r + ' rokov')) + ')'; }
    return m;
  };
  /**
   * Celý výpočet. v = { cena, vopred, mes } v centoch / mesiacoch; par = { sadzba, minMes, maxMes, minUver, maxUver } (maxUver a minUver v centoch).
   * Banka financuje najviac maxUver — čo je nad ním, ide do sumy „vopred“ (strop = true).
   */
  KS.vypocet = function (v, par) {
    var cena = Math.round(v.cena), mes = Math.round(v.mes), vopredZad = Math.max(0, Math.round(v.vopred || 0));
    var out = { ok: false, kod: '', cena: cena, mes: mes };
    if (!(cena > 0)) { out.kod = 'cena'; return out; }
    if (!(mes >= par.minMes && mes <= par.maxMes)) { out.kod = 'mes'; return out; }
    var vopred = Math.min(vopredZad, cena), strop = false;
    if (cena - vopred > par.maxUver) { vopred = cena - par.maxUver; strop = true; }
    var uver = cena - vopred;
    out.vopred = vopred; out.vopredZadane = vopredZad; out.uver = uver; out.strop = strop;
    if (uver === 0) { out.kod = 'bez-uveru'; return out; }
    if (uver < par.minUver) { out.kod = 'maly-uver'; return out; }
    var h = KS.harmonogram(uver, mes, par.sadzba);
    out.ok = true; out.splatka = h.splatka; out.posledna = h.posledna; out.celkom = h.celkom; out.urok = h.urok;
    out.celkomVsetko = vopred + h.celkom; out.preplatok = h.celkom - uver; out.rpmn = KS.rpmn(par.sadzba);
    return out;
  };
  /* /KS-CORE */

  var KROK = 10;                                   /* krok posuvníkov úveru a akontácie v eurách */
  var NBSP = String.fromCharCode(160);
  var CLANOK = '/blogs/novinky/tatra-banka-na-splatky';
  var NB = {};

  /** číslo do poľa: celé eurá bez centov („9 500“), inak s centmi („2 521,99“) */
  NB.vPole = function (c) { return c % 100 === 0 ? String(c / 100).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) : KS.eur(c).slice(0, -2); };
  function klamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  /**
   * Rozsahy boxu pre cenu v centoch: úver od minUver po min(cena, maxUver), akontácia je zvyšok (úver + akontácia = cena).
   * Posuvníky ide po KROK eurách; horný koniec posuvníka úveru znamená celý rozsah (aj keď cena nie je násobok kroku).
   */
  NB.rozsah = function (cena, par) {
    var umin = par.minUver, umax = Math.min(cena, par.maxUver), akmin = cena - umax, akmax = cena - umin;
    return {
      cena: cena, umin: umin, umax: umax, akmin: akmin, akmax: akmax,
      uSlMin: umin / 100, uSlMax: umin / 100 + Math.floor((umax - umin) / 1000) * KROK,
      akSlMin: Math.ceil(akmin / 1000) * KROK, akSlMax: Math.floor(akmax / 1000) * KROK
    };
  };
  /** nová výška úveru (centy) z posuvníka úveru / z poľa úveru / z posuvníka a poľa akontácie — všetko ide cez úver, akontácia = cena − úver */
  NB.zUveruSlidera = function (r, v) { return v >= r.uSlMax ? r.umax : klamp(v * 100, r.umin, r.umax); };
  NB.zUveruPola = function (r, c) { return klamp(c, r.umin, r.umax); };
  NB.zAkSlidera = function (r, v) { return r.cena - klamp(v * 100, r.akmin, r.akmax); };
  NB.zAkPola = function (r, c) { return r.cena - klamp(c, r.akmin, r.akmax); };
  /** poloha posuvníkov pre danú výšku úveru */
  NB.poziciaUver = function (r, uver) { return uver >= r.umax ? r.uSlMax : klamp(Math.floor((uver + 500) / 1000) * KROK, r.uSlMin, r.uSlMax); };
  NB.poziciaAk = function (r, uver) { return klamp(Math.floor((r.cena - uver + 500) / 1000) * KROK, r.akSlMin, r.akSlMax); };

  /** text pod číslom: celý reprezentatívny príklad v jednom riadku (sadzba, poplatok, RPMN, celková čiastka) + varovanie */
  NB.pravne = function (res, par) {
    return 'Fixná úroková sadzba ' + String(par.sadzba).replace('.', ',') + ' % p. a. · výška úveru ' + KS.eur(res.uver) + ' · poplatok za úver 0' + NBSP + '€ · RPMN ' + KS.pct(res.rpmn) + ' % · celková čiastka ' + KS.eur(res.celkom) +
      '. Orientačný výpočet, úver poskytuje Tatra banka, a. s. <strong>Pozor! Požičanie peňazí stojí peniaze.</strong>';
  };
  /** `odp` = popis odpočtu pri zvolenom tlačidle („po štátnej dotácii“ …) — cena v príklade je potom výslovne označená ako orientačná cena po odpočte */
  NB.tabulka = function (res, par, odp) {
    var r = function (a, b) { return '<tr><td>' + a + '</td><td>' + b + '</td></tr>'; };
    return '<table class="nb__tab">' + r(odp ? 'Cena nákupu (' + odp + ', orientačne)' : 'Cena nákupu', KS.eur(res.cena)) + r('Akontácia (vopred)', KS.eur(res.vopred)) + r('Výška úveru', KS.eur(res.uver)) +
      r('Doba splatnosti', res.mes + ' mesiacov') + r('Mesačná splátka', KS.eur(res.splatka)) + r('Posledná splátka', KS.eur(res.posledna)) + r('Úroková sadzba (fixná)', String(par.sadzba).replace('.', ',') + ' % p. a.') +
      r('Poplatok za úver', '0,00' + NBSP + '€') + r('RPMN', KS.pct(res.rpmn) + ' %') + r('Celková čiastka', KS.eur(res.celkom)) + '</table>';
  };
  /** rozbalená časť „Viac informácií“ */
  NB.viac = function (res, par, odp) {
    var od = NB.vPole(par.minUver) + NBSP + '€', po = NB.vPole(par.maxUver) + NBSP + '€';
    return '<div class="nb__cmp"><div><h4>Priama platba' + (odp ? ' (' + odp + ')' : '') + '</h4><b>' + KS.eur(res.cena) + '</b></div><div class="na"><h4>Na splátky</h4><b>' + KS.eur(res.celkomVsetko) + '</b></div></div>' +
      '<p class="nb__poz">Za rozloženie platby zaplatíte celkovo o <b>' + KS.eur(res.preplatok) + '</b> viac — to sú úroky. Cena zariadenia je rovnaká ako pri platbe naraz.</p>' + NB.tabulka(res, par, odp) +
      '<p class="nb__poz">Na splátky sa dá kúpiť zariadenie aj s montážou a príslušenstvom v jednej objednávke (úver od ' + od + ' do ' + po + ', ' + par.minMes + ' až ' + par.maxMes +
      ' mesiacov). Úver poskytuje Tatra banka, a. s.; o jeho poskytnutí rozhoduje banka (vek 18 až 64 rokov, príjem zo zamestnania, dôchodku alebo podnikania).</p>' +
      '<p class="nb__poz"><a class="nb__clanok" href="' + CLANOK + '">Čítať celý článok: Tatra banka na splátky →</a></p>';
  };
  /** okno nad „i“: reprezentatívny príklad s varovaním */
  NB.tip = function (res, par, odp) {
    return '<strong>Reprezentatívny príklad</strong>' + NB.tabulka(res, par, odp) + '<p class="nb__poz">Orientačný výpočet. <strong>Pozor! Požičanie peňazí stojí peniaze.</strong></p>';
  };

  /* ───────────── DOM ───────────── */
  var ref = function (root, n) { return root.querySelector('[data-nb="' + n + '"]'); };
  var tip = null, tipRoot = null, tipPin = false;

  function stav(root) {
    if (root.__nb) return root.__nb;
    var par = {
      sadzba: Number(root.getAttribute('data-sadzba')),
      minMes: Number(root.getAttribute('data-min-mes')), maxMes: Number(root.getAttribute('data-max-mes')),
      minUver: Number(root.getAttribute('data-min-uver')) * 100, maxUver: Number(root.getAttribute('data-max-uver')) * 100
    };
    var r = NB.rozsah(Number(root.getAttribute('data-cena')), par);
    var s = { root: root, par: par, r: r, uver: r.umax, mes: par.maxMes, res: null, odp: '' };
    root.__nb = s;
    var u = ref(root, 'uver-r'), m = ref(root, 'mes-r'), k = ref(root, 'ak-r');
    u.min = r.uSlMin; u.max = r.uSlMax; u.step = KROK;
    m.min = par.minMes; m.max = par.maxMes; m.step = 1;
    k.min = r.akSlMin; k.max = r.akSlMax; k.step = KROK;
    s.res = KS.vypocet({ cena: r.cena, vopred: r.cena - s.uver, mes: s.mes }, par);
    return s;
  }
  function prekresli(s, bez) {
    var r = s.r, par = s.par, root = s.root, ak = r.cena - s.uver;
    if (bez !== 'uver') ref(root, 'uver').value = NB.vPole(s.uver);
    if (bez !== 'ak') ref(root, 'ak').value = NB.vPole(ak);
    if (bez !== 'mes') ref(root, 'mes').value = s.mes;
    ref(root, 'uver-r').value = NB.poziciaUver(r, s.uver);
    ref(root, 'ak-r').value = NB.poziciaAk(r, s.uver);
    ref(root, 'mes-r').value = s.mes;
    var res = KS.vypocet({ cena: r.cena, vopred: ak, mes: s.mes }, par);
    s.res = res;
    ref(root, 'spl').textContent = res.ok ? KS.eur(res.splatka) : '–';
    ref(root, 'dobu').textContent = KS.mesTxt(s.mes);
    var od = ref(root, 'odp');
    od.textContent = s.odp ? 'pre cenu ' + s.odp : '';
    od.hidden = !s.odp;
    ref(root, 'legal').innerHTML = res.ok ? NB.pravne(res, par) : 'Zadajte výšku úveru od ' + NB.vPole(par.minUver) + NBSP + '€.';
    var more = ref(root, 'more');
    if (!more.hidden) more.innerHTML = res.ok ? NB.viac(res, par, s.odp) : '';
    if (tip && tipRoot === root && tip.style.display === 'block') tip.innerHTML = res.ok ? NB.tip(res, par, s.odp) : '';
    sinc(root, s);
    /* podmienky pre formulár „na splátky“ (assets/… a snippets/product-cta-dopyt.liquid): udalosť nesie čísla z toho istého výpočtu */
    if (root.dispatchEvent && typeof CustomEvent === 'function') root.dispatchEvent(new CustomEvent('cs-splatky-zmena', { bubbles: true, detail: { ok: !!res.ok, cena: r.cena, vopred: res.vopred || 0, uver: res.uver || 0, mes: s.mes, splatka: res.splatka || 0, celkom: res.celkom || 0, odp: s.odp, sadzba: par.sadzba, rpmn: res.rpmn || 0 } }));
  }

  function tipUkaz(root, i, pin) {
    var s = stav(root);
    if (!s.res || !s.res.ok) return;
    if (!tip) {
      tip = document.createElement('div'); tip.className = 'nb-tip'; tip.id = 'nb-tip'; tip.setAttribute('role', 'tooltip');
      document.body.appendChild(tip);
    }
    tipRoot = root; tipPin = !!pin;
    tip.innerHTML = NB.tip(s.res, s.par, s.odp); tip.style.display = 'block';
    i.setAttribute('aria-describedby', 'nb-tip');
    var b = i.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    tip.style.left = Math.min(Math.max(8, b.left - 20), window.innerWidth - w - 8) + 'px';
    var top = b.top - h - 8 < 8 ? b.bottom + 8 : b.top - h - 8;
    tip.style.top = Math.max(8, Math.min(top, window.innerHeight - h - 8)) + 'px';
  }
  function tipSkry() {
    if (!tip) return;
    tip.style.display = 'none'; tipPin = false;
    if (tipRoot) { var i = ref(tipRoot, 'i'); if (i) i.removeAttribute('aria-describedby'); }
  }
  var vBoxe = function (t) { return t && t.closest ? t.closest('.nb') : null; };
  var nazov = function (t) { return t && t.getAttribute ? t.getAttribute('data-nb') : null; };

  document.addEventListener('input', function (e) {
    var t = e.target, n = nazov(t), root = n && vBoxe(t);
    if (!root) return;
    var s = stav(root), r = s.r, c;
    if (n === 'uver-r') s.uver = NB.zUveruSlidera(r, Number(t.value));
    else if (n === 'ak-r') s.uver = NB.zAkSlidera(r, Number(t.value));
    else if (n === 'mes-r') s.mes = Number(t.value);
    else if (n === 'uver') { c = KS.centy(t.value); if (isNaN(c)) return; s.uver = NB.zUveruPola(r, c); }
    else if (n === 'ak') { c = KS.centy(t.value); if (isNaN(c)) return; s.uver = NB.zAkPola(r, c); }
    else if (n === 'mes') { c = parseInt(t.value, 10); if (!(c >= 1)) return; s.mes = klamp(c, s.par.minMes, s.par.maxMes); }
    else return;
    prekresli(s, n);
  });
  document.addEventListener('change', function (e) {
    var t = e.target, n = nazov(t), root = n && vBoxe(t);
    if (root && (n === 'uver' || n === 'ak' || n === 'mes')) prekresli(stav(root));
  });
  /** tlačidlá „Cena tepelného čerpadla po zľave XY % / … po štátnej dotácii / Cena po štátnej dotácii a cashbacku“ (pokyn Radovana 18. 10. 2026): splátky sa prepočítajú pre CENU PO ODPOČTE (data-cena tlačidla = cena zo zeleného rámika), akontácia je 0,
      doba splácania ostáva; cena v príklade je výslovne označená popisom odpočtu (data-odp), aby príklad nepredstieral, že cena setu je nižšia. */
  function scenar(btn, root) {
    var s = stav(root), c = Number(btn.getAttribute('data-cena'));
    if (!(c >= s.par.minUver)) return;
    var mes = s.mes;
    root.setAttribute('data-cena', String(c));
    root.__nb = null;
    s = stav(root);
    s.mes = klamp(mes, s.par.minMes, s.par.maxMes);
    s.odp = btn.getAttribute('data-odp') || '';
    prekresli(s);
  }
  /** stav tlačidiel podľa aktuálnej ceny boxu: zvolené je prvé, ktorého cena sa zhoduje; poznámka sa ukáže pri zvolenom odpočte */
  function sinc(root, s) {
    var g = ref(root, 'scen-skupina');
    if (!g) return;
    var tl = g.children, zap = -1;
    for (var k = 0; k < tl.length; k++) {
      var on = zap < 0 && Number(tl[k].getAttribute('data-cena')) === s.r.cena;
      if (on) zap = k;
      tl[k].classList.toggle('is-on', on);
      tl[k].setAttribute('aria-pressed', String(on));
    }
    ref(root, 'scen-poz').hidden = !(zap > 0);
  }
  /** zbalený box ukazuje len mesačnú splátku, počet splátok a úrokovú sadzbu s príkladom; tlačidlo ukáže alebo skryje celé nastavenie a „Viac informácií“ */
  function zbal(root, btn) {
    var otvor = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(otvor));
    ref(root, 'nast').hidden = !otvor;
    ref(root, 'dalsie').hidden = !otvor;
    ref(root, 'zbal-t').textContent = otvor ? 'Zbaliť nastavenie' : 'Nastaviť si vlastné splátky';
  }
  document.addEventListener('click', function (e) {
    var t = e.target, sb = t && t.closest ? t.closest('[data-nb="scen"]') : null;
    if (sb) t = sb;
    var zb = !sb && t && t.closest ? t.closest('[data-nb="zbal"]') : null;
    if (zb) t = zb;
    var n = nazov(t), root = n && vBoxe(t);
    if (root && n === 'zbal') { if (tip && tipPin) tipSkry(); zbal(root, t); return; }
    if (root && n === 'scen') { if (tip && tipPin) tipSkry(); scenar(t, root); return; }
    if (root && n === 'viac') {
      var s = stav(root), more = ref(root, 'more');
      more.hidden = !more.hidden;
      t.setAttribute('aria-expanded', String(!more.hidden));
      t.textContent = more.hidden ? 'Viac informácií ▾' : 'Menej informácií ▴';
      more.innerHTML = more.hidden || !s.res || !s.res.ok ? '' : NB.viac(s.res, s.par, s.odp);
      return;
    }
    if (root && n === 'i') {
      e.preventDefault();
      if (tipPin && tipRoot === root && tip.style.display === 'block') tipSkry(); else tipUkaz(root, t, true);
      return;
    }
    if (tip && tipPin) tipSkry();
  });
  document.addEventListener('mouseover', function (e) { var t = e.target, root = nazov(t) === 'i' && vBoxe(t); if (root && !tipPin) tipUkaz(root, t, false); });
  document.addEventListener('mouseout', function (e) { if (nazov(e.target) === 'i' && !tipPin) tipSkry(); });
  document.addEventListener('focusin', function (e) { var t = e.target, root = nazov(t) === 'i' && vBoxe(t); if (root && !tipPin) tipUkaz(root, t, false); });
  document.addEventListener('focusout', function (e) { if (nazov(e.target) === 'i' && !tipPin) tipSkry(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tipSkry(); });
  window.addEventListener('scroll', function () { if (tip && tip.style.display === 'block') tipSkry(); }, { passive: true });

  /* init(koren, stav): nastaví kópiu boxu (kalkulačka v paneli „na splátky“) podľa stavu zdroja (výška úveru, doba, odpočet, cena) a oznámi jej podmienky.
     Bez stavu zostane východiskový stav ako pri vykreslení. Kópia je vlastný koreň, takže jej zmeny sa do zdroja nepremietnu. */
  window.__csSplatkyBox = { KS: KS, NB: NB, init: function (root, st) {
    if (!root) return;
    var s = stav(root);
    if (st && st.r && st.r.cena !== s.r.cena && st.r.cena >= s.par.minUver) {
      root.setAttribute('data-cena', String(st.r.cena));
      root.__nb = null;
      s = stav(root);
    }
    if (st) {
      s.uver = Math.min(Math.max(st.uver, s.r.umin), s.r.umax);
      s.mes = Math.min(Math.max(st.mes, s.par.minMes), s.par.maxMes);
      s.odp = st.odp || '';
    }
    prekresli(s);
  } };
})();
